import { render, staticRenderFns } from "./shoparea.vue.vue?vue&type=template&id=dc376d74&"
import script from "./shoparea.vue.vue?vue&type=script&lang=js&"
export * from "./shoparea.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports